var IsFormValid = function (token) {
    var isValid = true;
    if (!ValidateCustomerCode())
        isValid = false;
    if (!ValidateCustomerEmail())
        isValid = false;
    if (!ValidateFirstName())
        isValid = false;
    if (!ValidateLastName())
        isValid = false;
    if (!ValidatePhoneAndMobile())
        isValid = false;
    if (!ValidateTerms())
        isValid = false;
    return isValid;
}

var IsRecapchaValid = function (token) {
    var isValid = true;
    var siteKey = document.getElementById('reCaptchaV3SiteKey').value;

    grecaptcha.ready(function () {
        grecaptcha.execute(siteKey, { action: 'register_myaccount' }).then(function (token) {
            $.ajax({
                method: "POST",
                dataType: 'JSON',
                url: "api/register/ValidateRecaptcha",
                async: false,
                data: JSON.stringify(token),
                contentType: "application/json",
                success: function (response) {
                    if (response.status == "Valid") {
                        $('#reCaptchaErrorMsgInner').html('');
                        $('#reCaptchaErrorMsg').hide();
                        isValid = true;
                    }
                    else {
                        $('#reCaptchaErrorMsgInner').html(response.status);
                        $('#reCaptchaErrorMsg').show();
                        isValid = false;
                    }
                },
                failure: function (response) {
                    $('#reCaptchaErrorMsgInner').html(response.status);
                    $('#reCaptchaErrorMsg').show();
                    $("#middys-overlay").hide();
                    isValid = false;
                }
            });
        });
    });
    return isValid;
}


// Customer Code Validation
ValidateCustomerCode = function () {
    var customerCode = $("#account-code").val();
    var regex = /^[a-zA-Z0-9\s]{3,10}$/;
    if (customerCode == "" || customerCode == null || customerCode == undefined) {
        $('#account-code').addClass("field-error");
        $("#cust-code-error").text('Customer code is required');
        $("#cust-code-error").show();
        return false;
    }
    else if (customerCode.length > 10) {
        $('#account-code').addClass("field-error");
        $("#cust-code-error").text('Your entry exceeds the maximum character limit. Please try again');
        $("#cust-code-error").show();
        return false;
    }
    else if (!regex.test(customerCode)) {
        $('#account-code').addClass("field-error");
        $("#cust-code-error").text('Customer code is required');
        $("#cust-code-error").show();
        return false;
    }
    else {
        $('#account-code').removeClass("field-error");
        $("#cust-code-error").hide();
        return true;
    }
}
// Email Validation
ValidateCustomerEmail = function () {
    var email = $("#emailAddress").val();

    if (email == "" || email == null || email == undefined) {
        $('#emailAddress').addClass("field-error");
        $("#cust-email-error").text('Email Address is required');
        $("#cust-email-error").show();
        $("#cust-email-errorCharLength").hide();
        return false;
    }
    else if (email.length > 60) {
        $('#emailAddress').addClass("field-error");
        $("#cust-email-errorCharLength").show();
        $("#cust-email-error").hide();
    }
    else if (!ValidateEmailRegex(email)) {
        $('#emailAddress').addClass("field-error");
        $("#cust-email-error").text('Email Address is required');
        $("#cust-email-error").show();
        $("#cust-email-errorCharLength").hide();
        return false;
    }
    else if (!IsInputSecure(email, true)) {
        $('#emailAddress').addClass("field-error");
        $("#cust-email-error").text("Your entry contains invalid characters. Please try again");
        $("#cust-email-error").show();
        $("#cust-email-errorCharLength").hide();
        return false;
    }
    else {
        $('#emailAddress').removeClass("field-error");
        $("#cust-email-error").hide();
        $("#cust-email-errorCharLength").hide();
        return true;
    }
}

ValidateFirstName = function () {
    var fname = $("#fname").val();
    if (fname == "" || fname == null || fname == undefined) {
        $('#fname').addClass("field-error");
        $("#cust-fname-error").show();
        $("#cust-fname-errorCharLength").hide();
        $("#cust-fname-errorInvalidChar").hide();
        return false;
    }
    else if (fname.length > 50) {
        $('#fname').addClass("field-error");
        $("#cust-fname-errorCharLength").show();
        $("#cust-fname-error").hide();
        $("#cust-fname-errorInvalidChar").hide();
        return false;
    }
    else if (!IsInputNameValid(fname)) {
        $('#fname').addClass("field-error");
        $("#cust-fname-errorInvalidChar").show();
        $("#cust-fname-error").hide();
        $("#cust-fname-errorCharLength").hide();
        return false;
    }
    else {
        $('#fname').removeClass("field-error");
        $("#cust-fname-error").hide();
        $("#cust-fname-errorCharLength").hide();
        $("#cust-fname-errorInvalidChar").hide();
        return true;
    }
}
ValidateLastName = function () {
    var lname = $("#lname").val();
    if (lname == "" || lname == null || lname == undefined) {
        $('#lname').addClass("field-error");
        $("#cust-lname-error").show();
        $("#cust-lname-errorCharLength").hide();
        $("#cust-lname-errorInvalidChar").hide();
        return false;
    }
    else if (lname.length > 50) {
        $('#lname').addClass("field-error");
        $("#cust-lname-errorCharLength").show();
        $("#cust-lname-error").hide();
        $("#cust-lname-errorInvalidChar").hide();
        return false;
    }
    else if (!IsInputNameValid(lname)) {
        $('#lname').addClass("field-error");
        $("#cust-lname-errorInvalidChar").show();
        $("#cust-lname-error").hide();
        $("#cust-lname-errorCharLength").hide();
        return false;
    }
    else {
        $('#lname').removeClass("field-error");
        $("#cust-lname-error").hide();
        $("#cust-lname-errorCharLength").hide();
        $("#cust-lname-errorInvalidChar").hide();
        return true;
    }
}
ValidatePhoneAndMobile = function () {
    var mobile = $("#mobile").val();
    var phone = $("#phone").val();

    $("#cust-mob-error").hide();
    $("#cust-mob-errorCharLength").hide();

    $("#cust-phone-error").hide();
    $("#cust-phone-errorCharLength").hide();

    if (!mobile && !phone) {
        $('#mobile').addClass("field-error");
        $('#phone').addClass("field-error");
        $("#cust-mob-error").text("Either Mobile or Phone (Other) is required");
        $("#cust-mob-error").show();
        return false;
    }
    else {
        var contactValid = true;
        if (!ValidateMobile(mobile))
            contactValid = false;
        if (!ValidatePhone(phone))
            contactValid = false;
        return contactValid;
    }
}

ValidateMobile = function (mobile) {
    if (mobile && mobile.length > 15) {
        $('#mobile').addClass("field-error");
        $("#cust-mob-errorCharLength").show();
        return false;
    }
    else if (mobile && !IsMobileValid(mobile)) {
        $('#mobile').addClass("field-error");
        $("#cust-mob-error").text("Mobile number is required");
        $("#cust-mob-error").show();
        return false;
    }
    else {
        $('#mobile').removeClass("field-error");
        $("#cust-mob-error").hide();
        $("#cust-mob-errorCharLength").hide();
        return true;
    }
}
ValidatePhone = function (phone) {
    if (phone && phone.length > 15) {
        $('#phone').addClass("field-error");
        $("#cust-phone-errorCharLength").show();
        return false;
    }
    else if (phone && !ValidatePhoneRegex(phone)) {
        $('#phone').addClass("field-error");
        $("#cust-phone-error").text("Contact number is required");
        $("#cust-phone-error").show();
        return false;
    }
    else {
        $('#phone').removeClass("field-error");
        $("#cust-phone-error").hide();
        $("#cust-phone-errorCharLength").hide();
        return true;
    }
}

// Terms validation
ValidateTerms = function () {
    var terms = document.getElementById('terms').checked;
    if (terms) {
        $('#terms').removeClass("field-error");
        $("#cust-terms").hide();
        return true;
    }
    else {
        $('#terms').addClass("field-error");
        $("#cust-terms").show();
        return false;
    }
}



var UserBackClick = function () {
    $("#user-exists").hide();
    ClearRegistrationForm();
    $("#registration-form").show();
}

var ClearRegistrationForm = function () {
    $('#registration-form input[type=text],#registration-form input[type=email],#registration-form input[type=number]').val('');
}

var WrongBackClick = function () {
    $(".site-error").hide();
    ClearRegistrationForm();
    $("#registration-form").show();
}
var InValidAccountBackClick = function () {
    $(".invalid-account-error").hide();
    $("#registration-form").show();
    $(".account-exist.trade-account").children().remove();
}

// Validate ABN Number

var ValidateABNNumber = function (event) {
    $(".invalid-ABN").hide();
    if (IsValidABN()) {
        $("#abn-error").hide(); $('#abn-number').removeClass("field-error");
        var parameters = {
            Email: $("#emailAddress").val(),
            ABNNumber: $("#abn-number").val(),
            AccountNumber: $("#account-code").val(),
            FirstName: $("#fname").val(), LastName: $("#lname").val(),
            Mobile: $("#mobile").val(), Phone: $("#phone").val(),
        };
        $("#middys-overlay").show();
        $.ajax({
            method: "POST",
            dataType: 'JSON',
            url: "api/register/ValidateABN",
            async: false,
            data: JSON.stringify(parameters),
            contentType: "application/json",
            success: function (response) {
                $("#middys-overlay").hide();
                if (response.status == "Confirm") {
                    switch (response.code) {
                        case "5":
                            $(".abn-lookup").hide();
                            $(".validate-form").show();
                            if ($(".validate-password-email").length > 0) {
                                $(".validate-password-email").append($("#emailAddress").val());
                            }
                            break;
                        case "6":
                            $(".abn-lookup").hide();
                            $(".acct-success").show();
                            addGoogleAnalyticsEvent({
                                event: "myAccountRegistration",
                                company: $("#account-code").val(),
                            });
                            break;
                        case "10":
                            $(".abn-lookup").hide();
                            $(".account-error").show();
                            break;
                        case "0":
                            $(".abn-lookup").hide();
                            $(".site-error").show();
                            break;
                    }
                }
                else if (response.status == "Reject") {
                    $(".abn-error-msg").text(response.code);
                    $(".invalid-ABN").show();
                }
                else {
                    $(".abn-lookup").hide();
                    $(".site-error").show();
                }
            },
            failure: function () {
                $("#middys-overlay").hide();
            },
            //error: function (response) {
            //    alert("error");
            //}
        });
    }
    return false;
}

IsValidABN = function () {
    var abn_number = $("#abn-number").val(); var abn_regex = /^(\s*\d\s*){11}$/;
    if (abn_number == "" || abn_number == null || abn_number == undefined) {
        $('#abn-number').addClass("field-error");
        $("#abn-error").text('Please enter a valid ABN');
        $("#abn-error").show();
        return false;
    }
    else if (!abn_regex.test(abn_number)) {
        $('#abn-number').addClass("field-error");
        $("#abn-error").text('Please enter a valid ABN');/*'Valid 11 digit ABN is required.');*/
        $("#abn-error").show();
        return false;
    }
    else if (abn_number.replace(/ /g, '').length == 11 && !IsValidAbn(abn_number)) {
        $('#abn-number').addClass("field-error");
        $("#abn-error").text('Please enter a valid ABN');
        $("#abn-error").show();
        return false;
    }
    else {
        $('#abn-number').removeClass("field-error");
        $("#abn-error").hide();
        return true;
    }
}
function IsValidAbn(abn) { //51 824 753 556
    abn = abn.replace(/ /g, ''); // strip spaces

    weight = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
    weightedSum = 0;

    //0. ABN must be 11 digits long
    if (abn.length != 11 || isNaN(parseInt(abn))) {
        return false;
    }
    //Rules: 1,2,3
    $.each(weight, function (i, val) {
        // console.log(abn[i]);
        weightedSum += (parseInt(abn[i]) - (i == 0 ? 1 : 0)) * weight[i];
    });
    //Rules: 4,5
    return (weightedSum % 89) == 0;
}
// Validate Invoices and Statement

var ValidateInvoicesAndStatement = function (event) {
    $(".invalid-invoice").hide();
    if (ValidateInvoiceDetails()) {
        var invoiceAndStatement = {
            AccountNumber: $("#account-code").val(),
            FirstInvoice: $("#first-invoice").val(),
            SecondInvoice: $("#second-invoice").val(),
            StatementDate: $("#statement-date").val(),
            StatementBalance: $("#statement-bal").val().replace(/,/g, ''),
            FirstName: $("#fname").val(), LastName: $("#lname").val(),
            Mobile: $("#mobile").val(), Phone: $("#phone").val(),
            Email: $("#emailAddress").val(),
        };
        $("#middys-overlay").show();
        $.ajax({
            method: "POST",
            dataType: 'JSON',
            url: "api/register/ValidateInvoicesAndStatement",
            async: false,
            data: JSON.stringify(invoiceAndStatement),
            contentType: "application/json",
            success: function (response) {
                $("#middys-overlay").hide();
                if (response.status == "Confirm") {
                    switch (response.code) {
                        case "5":
                            $(".invoices-statement").hide();
                            $(".validate-form").show();
                            if ($(".validate-password-email").length > 0) {
                                $(".validate-password-email").append($("#emailAddress").val() + ".");
                            }
                            break;
                        case "6":
                        case "2":
                            $(".invoices-statement").hide();
                            $(".acct-success").show();
                            addGoogleAnalyticsEvent({
                                event: "myAccountRegistration",
                                company: $("#account-code").val(),
                            });
                            break;
                        case "0":
                            $(".invoices-statement").hide();
                            $(".account-error").show();
                            break;
                    }
                }
                else if (response.status == "Reject") {
                    $(".invoice-error-msg").text(response.code);
                    $(".invalid-invoice").show();
                }
                else {
                    $(".invoices-statement").hide();
                    $(".account-error").show();
                }
            },
            failure: function (response) {
                $("#middys-overlay").hide();
            },
            //error: function (response) {
            //    alert("error");
            //}
        });
    }
    return false;
}
var ValidateInvoiceDetails = function () {
    var isValidInvoice = true;
    if (!ValidateFirstInvoice())
        isValidInvoice = false;
    if (!ValidateSecondInvoice())
        isValidInvoice = false;
    if (!ValidateStatementDate())
        isValidInvoice = false;
    if (!ValidateStatementBal())
        isValidInvoice = false;
    return isValidInvoice;
}

ValidateFirstInvoice = function () {
    var invoice1 = $("#first-invoice").val();
    if (invoice1 == "" || invoice1 == null || invoice1 == undefined) {
        $('#first-invoice').addClass("field-error");
        $("#invoice1-error").show();
        return false;
    }
    else {
        $('#first-invoice').removeClass("field-error");
        $("#invoice1-error").hide();
        return true;
    }
}

ValidateSecondInvoice = function () {
    var invoice2 = $("#second-invoice").val(); var invoice1 = $("#first-invoice").val();
    if (invoice2 == "" || invoice2 == null || invoice2 == undefined) {
        $('#second-invoice').addClass("field-error");
        $("#invoice2-error").text("Please enter a valid invoice number");
        $("#invoice2-error").show();
        return false;
    }
    else if (invoice1 == invoice2) {
        $('#second-invoice').addClass("field-error");
        $("#invoice2-error").text("Please enter a valid invoice number");/*First and second invoice numbers are same");*/
        $("#invoice2-error").show();
        return false;
    }
    else {
        $('#second-invoice').removeClass("field-error");
        $("#invoice2-error").hide();
        return true;
    }
}

ValidateStatementDate = function () {
    var stat_date = $("#statement-date").val();
    if (stat_date == "" || stat_date == null || stat_date == undefined) {
        $('#statement-date').addClass("field-error");
        $("#stat-date-error").show();
        return false;
    }
    else {
        $('#statement-date').removeClass("field-error");
        $("#stat-date-error").hide();
        return true;
    }
}

ValidateStatementBal = function () {
    var bal = $("#statement-bal").val();
    if (bal == "" || bal == null || bal == undefined) {
        $('#statement-bal').addClass("field-error");
        $("#stat-bal-error").show();
        return false;
    }
    else {
        $('#statement-bal').removeClass("field-error");
        $("#stat-bal-error").hide();
        return true;
    }
}

//$(document).ready(function () {
//    $("#registermyaccount-your-details-submit").click(function (e) {
//        $('.mob-phone').hide();
//    });
//});

// Validate password

var clicks = 0;

var ValidatePassword = function (event) {
    $("#confirm-password-error").hide();
    $(".invalid-password").hide();
    if (IsValidPassword()) {
        $("#confirm-password-error").hide(); $('#valid-password').removeClass("field-error");
        var parameters = {
            AccountNumber: $("#account-code").val(), Email: $("#emailAddress").val(),
            FirstName: $("#fname").val(),
            LastName: $("#lname").val(),
            Mobile: $("#mobile").val(),
            Phone: $("#phone").val(),
            Password: $('#valid-password').val(),
        };
        $("#middys-overlay").show();
        $.ajax({
            method: "POST",
            dataType: 'JSON',
            url: "api/register/ValidatePassword",
            async: false,
            data: JSON.stringify(parameters),
            contentType: "application/json",
            success: function (response) {
                $("#middys-overlay").hide();
                if (response != null) {
                    if (response.status == "1") {
                        $("#registration-form").hide();
                        $(".validate-form").hide();
                        $(".acct-success").show();
                        addGoogleAnalyticsEvent({
                            event: "myAccountRegistration",
                            company: $("#account-code").val(),
                        });
                    }
                    else if (response.status == "2") {
                        $(".password-error-msg").text(response.code);
                        $(".invalid-password").show();
                    }
                    else if (response.status == "0") {
                        $(".password-error-msg").text(response.code);
                        $(".invalid-password").show();

                        if (clicks >= 2) {
                            $(".password-error-msg").text("Reached maximum attempts");
                            $('#valid-password').attr("disabled", "disabled");
                            $('.btn-validate-password').attr("disabled", "disabled");
                        }
                        else
                            clicks++;
                        // alert('Wrong password');
                    }
                    else {
                        $(".validate-form").hide();
                        $(".site-error").show();
                    }
                }
            },
            failure: function () {
                $("#middys-overlay").hide();
            },
            //error: function (response) {
            //    alert("error");
            //}
        });
    }
    return false;
}
IsValidPassword = function () {
    var password = $("#valid-password").val();
    if (password == "" || password == null || password == undefined) {
        $('#valid-password').addClass("field-error");
        $("#confirm-password-error").text('Valid password is required.');
        $("#confirm-password-error").show();
        return false;
    }
    else {
        $('#valid-password').removeClass("field-error");
        $("#confirm-password-error").hide();
        return true;
    }
}

showHideValidatePassword = function () {
    var element = document.getElementById("valid-password");
    if (element.type == "password") {
        element.type = "text";
    }
    else if (element.type == "text") {
        element.type = "password";
    }
}
